import Store from "@/shared/global-store";
export interface NotificationAction {
  label: string;
  action: () => void;
  color?: string;
  variant?: "text" | "outlined" | "contained";
  icon?: string;
}

export interface NotificationOptions {
  persistent?: boolean;
  dismissible?: boolean;
  actions?: NotificationAction[];
}

export class GlobalNotificationService {
  static info(message: string, options?: NotificationOptions) {
    Store.showGlobalNotification({
      message,
      type: "info",
      persistent: options?.persistent,
      dismissible: options?.dismissible,
      actions: options?.actions,
    });
  }

  static success(message: string, options?: NotificationOptions) {
    Store.showGlobalNotification({
      message,
      type: "success",
      persistent: options?.persistent,
      dismissible: options?.dismissible,
      actions: options?.actions,
    });
  }

  static warning(message: string, options?: NotificationOptions) {
    Store.showGlobalNotification({
      message,
      type: "warning",
      persistent: options?.persistent,
      dismissible: options?.dismissible,
      actions: options?.actions,
    });
  }

  static error(message: string, options?: NotificationOptions) {
    Store.showGlobalNotification({
      message,
      type: "error",
      persistent: options?.persistent,
      dismissible: options?.dismissible,
      actions: options?.actions,
    });
  }

  static hide() {
    Store.hideGlobalNotification();
  }

  static get isActive() {
    return Store.state.globalNotification.show;
  }

  static confirm(
    message: string,
    onConfirm: () => void,
    onCancel?: () => void,
    options?: Omit<NotificationOptions, "actions">
  ) {
    const actions: NotificationAction[] = [
      {
        label: "Cancelar",
        action: () => {
          this.hide();
          if (onCancel) onCancel();
        },
        color: "grey",
        variant: "text",
      },
      {
        label: "Confirmar",
        action: () => {
          this.hide();
          onConfirm();
        },
        color: "primary",
      },
    ];

    Store.showGlobalNotification({
      message,
      type: "warning",
      persistent: options?.persistent !== false,
      dismissible: options?.dismissible !== false,
      actions,
    });
  }

  static withAction(
    message: string,
    actionLabel: string,
    actionCallback: () => void,
    type: "info" | "success" | "warning" | "error" = "info",
    options?: Omit<NotificationOptions, "actions">
  ) {
    const actions: NotificationAction[] = [
      {
        label: actionLabel,
        action: () => {
          this.hide();
          actionCallback();
        },
        color: type === "error" ? "error" : "primary",
      },
    ];

    Store.showGlobalNotification({
      message,
      type,
      persistent: options?.persistent,
      dismissible: options?.dismissible,
      actions,
    });
  }

  static updateAvailable(onUpdate: () => void, onLater?: () => void) {
    const actions: NotificationAction[] = [
      {
        label: "Mais tarde",
        action: () => {
          this.hide();
          if (onLater) onLater();
        },
        color: "grey",
        variant: "text",
      },
      {
        label: "Atualizar agora",
        action: () => {
          this.hide();
          onUpdate();
        },
        color: "primary",
        icon: "mdi-download",
      },
    ];

    Store.showGlobalNotification({
      message: "Uma nova versão está disponível!",
      type: "info",
      persistent: true,
      dismissible: false,
      actions,
    });
  }
}
